export class PiiRedactor {
  static rules = new Map([
    // Redact email address
    [/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, "[REDACTED EMAIL]"],

    // Redact IP address
    [/\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/g, "[REDACTED IP]"],
  ]);

  static redact(message: string): string {
    if (!message) return message;

    for (const [regex, replacement] of PiiRedactor.rules) {
      message = message.replace(regex, replacement);
    }

    return message;
  }
}
